<div class="modal-container">
  <h3 class="title" mat-dialog-title>Description de la boite numéro {{box?.box_number}}.</h3>
  <mat-divider></mat-divider>
  <mat-dialog-content class="mat-typography" style="padding-top: 25px">

    <strong style="text-decoration: underline;">Versement: </strong>
    <p [innerHTML]="box?.deposit_obj?.deposit_identifier"></p>

    <strong style="text-decoration: underline;">Description: </strong>
    <p *ngIf="box?.description; else defaultText" [innerHTML]="box?.description"></p>

    <strong style="text-decoration: underline;">Observation: </strong>
    <p *ngIf="box?.observation; else defaultText" [innerHTML]="box?.observation"></p>

    <strong style="text-decoration: underline;">Minimum révision date : </strong>
    <p *ngIf="box?.revision_year_min; else defaultText" [innerHTML]="box?.revision_year_min"></p>

    <strong style="text-decoration: underline;">Maximum révision date : </strong>
    <p *ngIf="box?.revision_year_max; else defaultText" [innerHTML]="box?.revision_year_max"></p>

    <ng-template #defaultText>
      <p>Aucune.</p>
    </ng-template>
  </mat-dialog-content>
</div>

